module.exports = __webpack_public_path__ + "static/media/skyPrecision2.1a10ac4b.png";